import ClientPenguin from './ClientPenguin'
import Penguin from './Penguin'
import NPCPenguin from './NPCPenguin'
import PenguinLoader from '@engine/loaders/PenguinLoader'


export default class PenguinFactory {

    constructor(world) {
        this.world = world

        this.penguinLoader = new PenguinLoader(world)
    }

    createPenguin(user, room) {
        if (!user || !user.id) {
            console.error('PenguinFactory: Cannot create penguin - user is null or missing id', user)
            return null
        }

        let client = this.world.client

        if (user.id == client.id) {
            client.penguin = new ClientPenguin(user, room)
            return client.penguin

        } else {
            return new Penguin(user, room)
        }
    }

    /**
     * Create an NPC penguin
     * @param {Object} npcData - NPC data from server
     * @param {Object} room - Room scene
     * @returns {NPCPenguin}
     */
    createNPCPenguin(npcData, room) {
        if (!npcData || !npcData.npcId) {
            console.error('PenguinFactory: Cannot create NPC - missing npcId', npcData)
            return null
        }

        return new NPCPenguin(npcData, room)
    }

    createPenguins(users, room) {
        let penguins = {}

        if (!users || !Array.isArray(users)) {
            return penguins
        }

        for (let user of users) {
            if (user && user.id && !(user.id in penguins)) {
                const penguin = this.createPenguin(user, room)
                if (penguin) {
                    penguins[user.id] = penguin
                }
            }
        }

        return penguins
    }

    /**
     * Create NPCs from array of NPC data
     * @param {Array} npcs - Array of NPC data objects
     * @param {Object} room - Room scene
     * @returns {Object} Dictionary of NPCs by ID
     */
    createNPCs(npcs, room) {
        let npcPenguins = {}

        if (!npcs || !Array.isArray(npcs)) {
            return npcPenguins
        }

        for (let npc of npcs) {
            if (npc && npc.npcId && !(npc.npcId in npcPenguins)) {
                const npcPenguin = this.createNPCPenguin(npc, room)
                if (npcPenguin) {
                    // Use the virtual ID (negative) as key for consistency with penguin lookup
                    npcPenguins[npcPenguin.id] = npcPenguin
                }
            }
        }

        return npcPenguins
    }

}
